import * as yup from 'yup';

const rolesSchemaBuilder = (obj: object) =>
  yup
    .object(
      Object.keys(obj).reduce(
        (previous, key) => ({
          ...previous,
          [key]: yup.array().min(1).nullable().required(),
        }),
        {},
      ),
    )
    .required();

export const defaultContactForm = () =>
  yup.object({
    adminId: yup.string().nullable().required(),
    roles: yup.lazy(rolesSchemaBuilder),
    notes: yup.string().nullable(),
  });

export const editDefaultContactForm = () =>
  yup.object({
    roles: yup.lazy(rolesSchemaBuilder),
    notes: yup.string().nullable(),
  });

export const defaultContactEditOrdersDialog = () =>
  yup.object({
    updateOrders: yup.boolean(),
    statusRange: yup.boolean(),
    updateType: yup.string().nullable(),
    statusLowerRange: yup.string().nullable().when('updateOrders', {
      is: true,
      then: yup.string().required(),
    }),
    statusUpperRange: yup.string().nullable().when('statusRange', {
      is: true,
      then: yup.string().required(),
    }),
  });

export const editDefaultContactFormWithDialog = () =>
  editDefaultContactForm().concat(defaultContactEditOrdersDialog());
